import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ColumnDataType, IColumn } from 'components/elements/table/type';
import { mealsOption } from 'legacy-modules/master/hotel/components/utils';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

interface Props {
  parentIndex: number;
}

function reducer(state, action, { update, clearErrors, name, setValue }) {
  switch (action.type) {
    case 'update_cell':
      return {
        ...state,
        data: state.data.map((row, index) => {
          if (index === action.rowIndex) {
            const tempValue = {
              ...state.data[action.rowIndex],
              [action.columnId]: action.value,
            };
            // update(index, tempValue);
            clearErrors(name);
            setValue(`${name}.${index}`, tempValue, { shouldValidate: true });
            return tempValue;
          }
          return row;
        }),
      };
    case 'update_all':
      return {
        ...state,
        data: action.newData,
      };
    default:
      return state;
  }
}

export default function InformationHotelTable(props: Props) {
  const { t } = useTranslation();
  const {
    control,
    formState: { isSubmitting },
    clearErrors,
    setValue,
  } = useFormContext();
  const { editable } = useFormState();

  const name: any = `hotelPurchases.${props.parentIndex}.hotelPurchaseHotels`;
  const isSelected = useWatch({
    control,
    name: `hotelPurchases.${props.parentIndex}.isSelected`,
  });

  const { fields, update } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const columns: IColumn<any>[] = [
    {
      header: t('common:check_in'),
      accessorKey: 'checkIn',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
      disabled: true,
    },
    {
      header: t('common:check_out'),
      accessorKey: 'checkOut',
      minSize: 150,
      maxSize: 180,
      dataType: ColumnDataType.date,
      disabled: true,
    },

    {
      header: t('common:meals'),
      accessorKey: 'detail',
      minSize: 100,
      maxSize: 150,
      dataType: ColumnDataType.select,
      options: mealsOption,
      disabled: true,
    },
    {
      header: t('common:pax'),
      accessorKey: 'pax',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      disabled: true,
    },
    {
      header: t('common:number_of_night'),
      accessorKey: 'night',
      minSize: 100,
      dataType: ColumnDataType.null,
      disabled: true,
    },
    {
      header: t('common:number_of_room'),
      accessorKey: 'room',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      disabled: true,
    },
    {
      header: t('common:room_type'),
      accessorKey: 'hotelRoomName',
      minSize: 100,
      dataType: ColumnDataType.text,
      disabled: true,
    },
    {
      header: t('common:price'),
      accessorKey: 'price',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
      disabled: true,
    },
    {
      header: t('common:refund_price'),
      accessorKey: 'refundPrice',
      minSize: 100,
      dataType: ColumnDataType.number,
      minNumber: 0,
    },
  ];

  const [isInitiate, setIsInitiate] = React.useState<{
    value: boolean;
    data: any;
  }>({ value: false, data: undefined });

  const [state, dispatch] = React.useReducer(
    (state, action) =>
      reducer(state, action, { update, clearErrors, name, setValue }),
    {
      columns,
      data: [],
    },
  );

  React.useEffect(() => {
    if (!isInitiate.value) {
      dispatch({
        type: 'update_all',
        newData: fields.length ? fields : [],
      });
      setIsInitiate({
        value: true,
        data: fields.length ? fields : [],
      });
    }
  }, [fields, isInitiate]);

  React.useEffect(() => {
    if (!editable && isInitiate.value && !isSubmitting) {
      dispatch({ type: 'update_all', newData: isInitiate.data });
    }
  }, [editable, isInitiate.value, isSubmitting, t, isInitiate.data]);

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={state.data}
        disabled={!editable || !isSelected}
        dispatch={dispatch}
        name={name}
        uniqueRowKey="customId"
        noAddRemoveRow
      />
    </div>
  );
}
